import React from 'react';
import { Base } from '@fiverr-private/modal/src';
import classNames from 'classnames';
import { string, array, func } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import FilterListModal from './modals/filter_list_modal';
import ScListModal from './modals/sc_list_modal';
import { LIST_TYPES } from './constants';

const LIST_TYPE_MAPPER = {
    [LIST_TYPES.SUBCATEGORIES]: ScListModal,
    [LIST_TYPES.FILTERS]: FilterListModal
};

const ViewAllTile = ({ image, alias, tileSize, items, onOpen, listType }) => {
    const ListComponent = LIST_TYPE_MAPPER[listType];

    return (
        <Base name="search_perseus listings-perseus list-modal"
            onOpen={onOpen}
            trigger={({ open }) => (
                <a className={classNames('tile box-shadow-z2 view-all-tile', tileSize)} onClick={() => open()}>
                    <img src={image} alt={alias}/>
                    <I18n k={'search_perseus.filter_tiles.view_all'}/>
                </a>)}>
            {({ close }) => (
                <ListComponent close={close} items={items}/>
            )}
        </Base>
    );
};

ViewAllTile.propTypes = {
    image: string,
    alias: string,
    tileSize: string,
    items: array,
    onOpen: func,
    listType: string
};

export default ViewAllTile;
